import { useState } from 'react'
import { Heading } from '@weareberyl/design-system'
import Table from '~/components/Table'
import {
  LoadingComponent,
  ErrorComponent,
  EmptyComponent,
} from '~/components/Query/utils'
import { compareAndShortenGeoms } from '~/utils'
import { useServiceAreaDiffQuery } from '~/gql/generated/graphql'

export default ({ serviceArea, columns }) => {
  const [[oldGeom, newGeom], setGeom] = useState(['-', '-'])

  const { loading, error, data } = useServiceAreaDiffQuery({
    variables: { id: serviceArea.id },
    pollInterval: 0,
    onCompleted: () => {
      setGeom(
        compareAndShortenGeoms(data?.service_area?.geom, serviceArea?.geom),
      )
    },
  })

  const cols = [
    {
      title: '',
      dataIndex: 'diffType',
      render: diffType => <Heading variant="h4">{diffType}</Heading>,
    },
    ...columns,
    {
      title: 'Geometry',
      dataIndex: 'geom',
    },
  ]

  if (error) {
    return <ErrorComponent error={error} />
  }

  if (loading) {
    return <LoadingComponent />
  }

  if (!data) {
    return <EmptyComponent />
  }

  return (
    <div>
      <Table
        id="service-areas-sync-table-diff"
        columns={cols}
        hideProgress
        data={{
          table: {
            pagination: false,
            nodes: [
              { ...serviceArea, geom: newGeom, diffType: 'New' },
              {
                ...data.service_area,
                id: 'old',
                geom: oldGeom,
                diffType: 'Old',
              },
            ],
          },
        }}
      />
    </div>
  )
}
